import TicketStatusDialogService from './TicketStatusDialogService';

export * from './TicketStatusDialogService.types';
export default TicketStatusDialogService;
